var H=e=>typeof e=="function",u=(e,t)=>H(e)?e(t):e;var U=(()=>{let e=0;return()=>(++e).toString()})(),$=e=>t=>{t&&setTimeout(()=>{let o=t.getBoundingClientRect();e(o)})},S=(()=>{let e;return()=>{if(e===void 0&&typeof window<"u"){let t=matchMedia("(prefers-reduced-motion: reduce)");e=!t||t.matches}return e}})();import{useEffect as W,useState as j}from"react";var Q=20;var A=new Map,L=e=>{if(A.has(e))return;let t=setTimeout(()=>{A.delete(e),m({type:4,toastId:e})},1e3);A.set(e,t)},J=e=>{let t=A.get(e);t&&clearTimeout(t)},E=(e,t)=>{switch(t.type){case 0:return{...e,toasts:[t.toast,...e.toasts].slice(0,Q)};case 1:return t.toast.id&&J(t.toast.id),{...e,toasts:e.toasts.map(a=>a.id===t.toast.id?{...a,...t.toast}:a)};case 2:let{toast:o}=t;return e.toasts.find(a=>a.id===o.id)?E(e,{type:1,toast:o}):E(e,{type:0,toast:o});case 3:let{toastId:s}=t;return s?L(s):e.toasts.forEach(a=>{L(a.id)}),{...e,toasts:e.toasts.map(a=>a.id===s||s===void 0?{...a,visible:!1}:a)};case 4:return t.toastId===void 0?{...e,toasts:[]}:{...e,toasts:e.toasts.filter(a=>a.id!==t.toastId)};case 5:return{...e,pausedAt:t.time};case 6:let r=t.time-(e.pausedAt||0);return{...e,pausedAt:void 0,toasts:e.toasts.map(a=>({...a,pauseDuration:a.pauseDuration+r}))}}},P=[],R={toasts:[],pausedAt:void 0},m=e=>{R=E(R,e),P.forEach(t=>{t(R)})},X={blank:4e3,error:4e3,success:2e3,loading:1/0,custom:4e3},v=(e={})=>{let[t,o]=j(R);W(()=>(P.push(o),()=>{let r=P.indexOf(o);r>-1&&P.splice(r,1)}),[t]);let s=t.toasts.map(r=>{var a,i;return{...e,...e[r.type],...r,duration:r.duration||((a=e[r.type])==null?void 0:a.duration)||(e==null?void 0:e.duration)||X[r.type],style:{...e.style,...(i=e[r.type])==null?void 0:i.style,...r.style}}});return{...t,toasts:s}};var q=(e,t="blank",o)=>({createdAt:Date.now(),visible:!0,type:t,ariaProps:{role:"status","aria-live":"polite"},message:e,pauseDuration:0,...o,id:(o==null?void 0:o.id)||U()}),g=e=>(t,o)=>{let s=q(t,e,o);return m({type:2,toast:s}),s.id},n=(e,t)=>g("blank")(e,t);n.error=g("error");n.success=g("success");n.loading=g("loading");n.custom=g("custom");n.dismiss=e=>{m({type:3,toastId:e})};n.remove=e=>m({type:4,toastId:e});n.promise=(e,t,o)=>{let s=n.loading(t.loading,{...o,...o==null?void 0:o.loading});return e.then(r=>(n.success(u(t.success,r),{id:s,...o,...o==null?void 0:o.success}),r)).catch(r=>{n.error(u(t.error,r),{id:s,...o,...o==null?void 0:o.error})}),e};import{useEffect as G,useMemo as K}from"react";var D=e=>{let{toasts:t,pausedAt:o}=v(e);G(()=>{if(o)return;let r=Date.now(),a=t.map(i=>{if(i.duration===1/0)return;let T=(i.duration||0)+i.pauseDuration-(r-i.createdAt);if(T<0){i.visible&&n.dismiss(i.id);return}return setTimeout(()=>n.dismiss(i.id),T)});return()=>{a.forEach(i=>i&&clearTimeout(i))}},[t,o]);let s=K(()=>({startPause:()=>{m({type:5,time:Date.now()})},endPause:()=>{o&&m({type:6,time:Date.now()})},updateHeight:(r,a)=>m({type:1,toast:{id:r,height:a}}),calculateOffset:(r,a)=>{let{reverseOrder:i=!1,gutter:T=8,defaultPosition:l}=a||{},c=t.filter(p=>(p.position||l)===(r.position||l)&&p.height),h=c.findIndex(p=>p.id===r.id),b=c.filter((p,y)=>y<h&&p.visible).length;return c.filter(p=>p.visible).slice(...i?[b+1]:[0,b]).reduce((p,y)=>p+(y.height||0)+T,0)}}),[t,o]);return{toasts:t,handlers:s}};import*as d from"react";import{styled as N,keyframes as B}from"goober";import*as f from"react";import{styled as w,keyframes as pe}from"goober";import{styled as Z,keyframes as I}from"goober";var ee=I`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,te=I`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,oe=I`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,k=Z("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ee} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${te} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e=>e.secondary||"#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${oe} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;import{styled as re,keyframes as ae}from"goober";var se=ae`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,V=re("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e=>e.secondary||"#e0e0e0"};
  border-right-color: ${e=>e.primary||"#616161"};
  animation: ${se} 1s linear infinite;
`;import{styled as ie,keyframes as z}from"goober";var ne=z`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,ce=z`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,_=ie("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ne} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${ce} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e=>e.secondary||"#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;var de=w("div")`
  position: absolute;
`,me=w("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,ue=pe`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,le=w("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${ue} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,M=({toast:e})=>{let{icon:t,type:o,iconTheme:s}=e;return t!==void 0?typeof t=="string"?f.createElement(le,null,t):t:o==="blank"?null:f.createElement(me,null,f.createElement(V,{...s}),o!=="loading"&&f.createElement(de,null,o==="error"?f.createElement(k,{...s}):f.createElement(_,{...s})))};var fe=e=>`
0% {transform: translate3d(0,${e*-200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`,Te=e=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e*-150}%,-1px) scale(.6); opacity:0;}
`,ye="0%{opacity:0;} 100%{opacity:1;}",ge="0%{opacity:1;} 100%{opacity:0;}",xe=N("div",d.forwardRef)`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,he=N("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,be=(e,t)=>{let s=e.includes("top")?1:-1,[r,a]=S()?[ye,ge]:[fe(s),Te(s)];return{animation:t?`${B(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards`:`${B(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`}},C=d.memo(({toast:e,position:t,style:o,children:s})=>{let r=e!=null&&e.height?be(e.position||t||"top-center",e.visible):{opacity:0},a=d.createElement(M,{toast:e}),i=d.createElement(he,{...e.ariaProps},u(e.message,e));return d.createElement(xe,{className:e.className,style:{...r,...o,...e.style}},typeof s=="function"?s({icon:a,message:i}):d.createElement(d.Fragment,null,a,i))});import{css as Se,setup as Ae}from"goober";import*as x from"react";Ae(x.createElement);var Pe=(e,t)=>{let o=e.includes("top"),s=o?{top:0}:{bottom:0},r=e.includes("center")?{justifyContent:"center"}:e.includes("right")?{justifyContent:"flex-end"}:{};return{left:0,right:0,display:"flex",position:"absolute",transition:S()?void 0:"all 230ms cubic-bezier(.21,1.02,.73,1)",transform:`translateY(${t*(o?1:-1)}px)`,...s,...r}},Re=Se`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,O=16,Oe=({reverseOrder:e,position:t="top-center",toastOptions:o,gutter:s,children:r,containerStyle:a,containerClassName:i})=>{let{toasts:T,handlers:l}=D(o);return x.createElement("div",{style:{position:"fixed",zIndex:9999,top:O,left:O,right:O,bottom:O,pointerEvents:"none",...a},className:i,onMouseEnter:l.startPause,onMouseLeave:l.endPause},T.map(c=>{let h=c.position||t,b=l.calculateOffset(c,{reverseOrder:e,gutter:s,defaultPosition:t}),F=Pe(h,b),p=c.height?void 0:$(y=>{l.updateHeight(c.id,y.height)});return x.createElement("div",{ref:p,className:c.visible?Re:"",key:c.id,style:F},c.type==="custom"?u(c.message,c):r?r(c):x.createElement(C,{toast:c,position:h}))}))};var Et=n;export{_ as CheckmarkIcon,k as ErrorIcon,V as LoaderIcon,C as ToastBar,M as ToastIcon,Oe as Toaster,Et as default,u as resolveValue,n as toast,D as useToaster,v as useToasterStore};
//# sourceMappingURL=index.mjs.map